import { change as changeFormValue } from 'redux-form';
import { connect } from 'react-redux';
import { ToggleBar } from '@eti/form';
const onChange = (dispatch, {
  isConfirmationEnabled,
  form,
  options,
  persuasionEnabled,
  priceRaw,
  setConfirmationIsOpen,
  setConfirmationOnConfirm,
  setConfirmationOnDecline,
  setPersuasionIsOpen,
  setPersuasionOnConfirm,
  setPersuasionOnDecline
}) => (_event, value, _prevValue, field) => {
  if (persuasionEnabled && value.value === false) {
    setPersuasionIsOpen(true);
    setPersuasionOnConfirm(() => () => {
      dispatch(changeFormValue(form, field, {
        value: options[1].value,
        priceRaw
      }));
      setPersuasionIsOpen(false);
    });
    setPersuasionOnDecline(() => () => {
      dispatch(changeFormValue(form, field, {
        value: options[0].value,
        priceRaw
      }));
      setPersuasionIsOpen(false);
    });
  }
  if (isConfirmationEnabled && value.value === true) {
    setConfirmationIsOpen(true);
    setConfirmationOnConfirm(() => () => {
      dispatch(changeFormValue(form, field, {
        value: options[1].value,
        priceRaw
      }));
      setConfirmationIsOpen(false);
    });
    setConfirmationOnDecline(() => () => {
      dispatch(changeFormValue(form, field, {
        value: options[0].value,
        priceRaw
      }));
      setConfirmationIsOpen(false);
    });
  }
};
const mapDispatchToProps = (dispatch, props) => ({
  onChange: onChange(dispatch, props)
});
export default connect(null, mapDispatchToProps)(ToggleBar);
//# sourceMappingURL=ToggleBarContainer.js.map